"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const shellContext_1 = require("contexts/shellContext");
const useShellContext = () => {
    const context = (0, react_1.useContext)(shellContext_1.ShellContext);
    if (!context) {
        throw new Error('useShellContext must be used within a ShellProvider');
    }
    return context;
};
exports.default = useShellContext;
